<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">警示教育></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>襄州区通报6起违反中央八项规定精神典型案例</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>
          <b>1.襄州区张家集镇林业服务中心工作人员张继辉违规领取补助、列支费用问题。</b>
        </h3>
        <h3>2014年1月至2016年10月，张继辉违规领取加班工资、误工补助、值班补贴；违反公务接待管理规定，对一函三单手续不齐的接待费进行违规报销；利用职务之便，违规列支应由其本人支付的摩托车加油费、维修费。相关违纪款已清退。2020年3月，张继辉受到党内警告处分。.21mg/100ml，为醉酒后驾车。同年8月，杨国徽因犯危险驾驶罪，被判处拘役2个月、缓刑2个月。2019年12月，杨国徽受到开除公职处分。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>2.襄州区张家集镇张集村原党支部书记、村委会主任张德元等3人超标准发放工资问题。</b>
        </h3>
        <h3>2014年1月，张德元，该村原党支部委员、站长张国斌，原妇女主任兼4组组长梁香娃违规超标准领取2013年村干部工资，造成集体经济损失。相关违纪款已清退。2020年3月，张德元、张国斌、梁香娃分别受到党内严重警告处分。.26mg/100ml，为醉酒后驾车。同年8月，李关键因犯危险驾驶罪，被判处拘役2个月、罚金3000元。2019年10月，李关键受到开除党籍、降低岗位等级处分。</h3>
        <h3>
          <b>3.襄州区黄集镇中心福利院工作人员金开龙违规发放津补贴、违规列支招待费问题。</b>
        </h3>
        <h3>2019年1月，金开龙采取虚假发放该院护理人员工资的方式，套取财政资金，违规为5名护理人员发放护理补贴，为其本人发放管理补贴，并报销应由黄集镇政府民政办支付的招待费。相关违纪款已清退。2020年4月，金开龙受到党内严重警告处分。.58mg/100ml，为醉酒后驾车。同年7月，胡建强因犯危险驾驶罪，被判处拘役2个月、缓刑3个月、罚金1万元。2019年9月，胡建强受到开除党籍处分。同年12月，胡建强受到降低岗位等级处分。</h3>
        <h3>
          <b>4.襄州区黄集镇马集村党支部委员、财经委员马天远大操大办婚丧喜庆事宜问题。</b>
        </h3>
        <h3>2019年12月，马天远在操办孙子满月宴的过程中，未向该镇纪委履行相关报备手续，并违规收受两名非亲戚关系的村组党员干部礼金。相关违纪款已清退。2020年3月，马天远受到党内警告处分。.43mg/100ml，为醉酒后驾车。同年6月，余国俭因犯危险驾驶罪，被判处拘役2个月，缓刑3个月，并处罚金1万元。2019年8月，余国俭受到开除党籍处分。同年9月，余国俭受到降低岗位等级处分。</h3>
        <h3>
          <b>5.襄州区伙牌镇张伙村党支部书记韩晓华等2人违规发放津补贴问题。</b>
        </h3>
        <h3>2017年12月，由韩晓华审批同意，该村原农经站长胡光普具体经办，违规为包含韩、胡二人在内的4名参加秸秆禁烧巡查的人员发放误工补助。相关违纪款已清退。2019年11月，胡光普受到诫勉谈话处理。2020年1月，韩晓华受到党内警告处分。.83mg/100ml，为饮酒后驾车。同年5月，襄州区公安局交警大队给予陈革春罚款2000元、暂扣机动车驾驶证6个月、扣12分的行政处罚。2019年12月，陈革春受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>6.襄州区程河镇苏坡村原党支部书记、村委会主任苏高平违规发放津补贴问题。</b>
        </h3>
        <h3>2015年5月至2017年12月，苏高平违规为村组干部发放秸秆禁烧误工补助及杂工工资。苏高平另有其他违纪问题。2020年3月，苏高平受到党内严重警告处分。（襄州区纪委监委）.23mg/100ml，为饮酒后驾车。同年11月，襄州区公安局交警大队给予齐庆峰行政罚款4000元、暂扣机动车驾驶证6个月、扣24分的行政处罚。2020年5月，齐庆峰受到党内严重警告处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumWarning" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>